'use strict';
require('../../../modules/es.array.concat');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'concat');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/concat.js
// module id = 556
// module chunks = 13